import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Text from "../../../../../../packages/design-system/src/Text";
import HdiIcon from "../../../../../../packages/design-system/src/InsurerIcons/HdiIcon";
import HelvetiaIcon from "../../../../../../packages/design-system/src/InsurerIcons/HelvetiaIcon";
import * as icons from "../../../../../../packages/design-system/src/InsurerIcons";
import * as React from 'react';
export default {
  Spacings,
  Text,
  HdiIcon,
  HelvetiaIcon,
  icons,
  React
};